import React, { useEffect, useState } from "react";
import { Form, Input, Table } from "antd";
import { prodajaData } from "../Form/formData";
import AddModal from "../Modal/index";
import { useDispatch } from "react-redux";

function Prodazha() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },

    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Klient",
      dataIndex: "klient",
    },
    {
      title: "Sklad",
      dataIndex: "sklad",
    },
    {
      title: "Kol-ov komplektov",
      dataIndex: "kol-ov_komplektov",
    },
    {
      title: "Kol-ov madelov",
      dataIndex: "kol-ov_madelov",
    },
    {
      title: "Kommentarii",
      dataIndex: "kommentarii",
    },
  ];

  return (
    <>
      <AddModal
        title={"Продажа"}
        width={1400}
        stil={"stil"}
        form={prodajaData}
        columnsAll={prodajaData[0].columns}
        columnsAll2={prodajaData[0].columns1}
        Visible={true}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default Prodazha;
